import { SVGProps } from 'react'

export const ArrowLeftIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M400-240 160-480l240-240 56 58-142 142h486v80H314l142 142-56 58Z"
      />
    </svg>
  )
}
